import { IParamsTable } from '~/interfaces/IParamsTable';
import { authFetch } from '~/services/fetch';
import { IUpdateProps } from '~/interfaces/IUpdateProps';
import IEquipment, { type getAllEquipmentsProps } from '../interfaces/IEquipment';

export async function getAllEquipments({equipmentByUserLogged = false}: getAllEquipmentsProps) {
  const url = equipmentByUserLogged ? '/equipment/all-for-logged-user' : '/equipment/';
  const response = await authFetch({
    url: url,
    method: 'POST',
  });
  return response.data;
}

export async function getEquipments({
  filters = [],
  limit = 100000,
  orders = [{ field: 'name', sort: 'asc' }],
  equipment,
  equipmentGroupId,
  agencyId,
  warehouseId,
  isAvailable,
  active,
}: IParamsTable & {
  readonly equipment?: string;
  readonly equipmentGroupId?: number;
  readonly agencyId?: number;
  readonly warehouseId?: number;
  readonly isAvailable?: boolean;
  readonly active?: boolean;
} = {}) {
  const response = await authFetch({
    url: '/equipment/',
    method: 'POST',
    data: {
      filters,
      orders,
      limit,
      equipment,
      equipment_group_id: equipmentGroupId,
      agency_id: agencyId,
      warehouse_id: warehouseId,
      is_available: isAvailable,
      active,
    },
  });
  return response.data;
}

export async function getEquipmentById(id: IUpdateProps) {
  const response = await authFetch({
    url: `/equipment/${id}`,
    method: 'GET',
  });
  return response.data;
}

export async function createEquipment(data: IEquipment) {
  const response = await authFetch({
    url: '/equipment/store',
    method: 'POST',
    data,
  });
  return response.data;
}

export async function updateEquipment(id: IUpdateProps, data: Partial<IEquipment>) {
  const response = await authFetch({
    url: `/equipment/${id}`,
    method: 'PUT',
    data,
  });
  return response.data;
}

export async function deleteEquipment(id: IUpdateProps) {
  const response = await authFetch({
    url: `/equipment/${id}`,
    method: 'DELETE',
  });
  return response.data;
}

export async function transferEquipment(id: IUpdateProps, warehouseId: number) {
  const response = await authFetch({
    url: `/equipment/transfer/${id}`,
    method: 'PUT',
    data: {
      warehouse_id: warehouseId,
    },
  });
  return response.data;
}

export async function deactivateEquipment(id: IUpdateProps) {
  const response = await authFetch({
    url: `/equipment/deactivate/${id}`,
    method: 'PUT',
  });
  return response.data;
}
